import images from "../../assets/images/assets";
import Button1 from "../SmallComponents/Button1";
import SectionImage02 from "../SmallComponents/SectionImage02";

const TestimonialSection = () => {
  return (
    <div className="bg-transparent w-full p-4 ">
      <div className="bg-transparent  p-4 md:p-8 h-screen col lg:flex-row-reverse gap-5">
        <div className="top col items-center lg:items-start gap-5 lg:mt-56 text-prime-red">
          <div>
            <h3 className="uppercase montserrat text-center lg:text-left lg:-mb-6 ">
              Testimonials
            </h3>

            <h2 className="playfair-display heading-1 ">John & Ann</h2>
          </div>

          <p className="montserrat text-center mt-4  relative md:w-3/4 lg:text-left lg:w-[90%]">
            <img
              src={images.quotes}
              alt="decorative"
              className="absolute -left-2 -top-7 md:-left-10 lg:left-100 lg:mirror-x "
            />
            With over 10 years of experience in the creative industry,{" "}
            <strong>it’s all about cards</strong> is an expert in crafting
            exceptional invitation cards that showcase the best of the event
            schedule. Their passion of creating and dedication to using only the
            finest, freshest designs is what sets this brand apart.
          </p>

          <Button1 title="See More" />
        </div>
        <div className="bottom md:px-20  flex-1 pt-10">
          <SectionImage02 image={images.testimonial_2} />
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
